export default __webpack_public_path__ + "static/media/responsive.06891001.svg";